import React from 'react'
import Badge from 'material-ui/Badge'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { selectNewMessages, selectNewBroadcasts } from '../../selectors/messagesSelector'
import { FETCH_NEW_MESSAGES_REQUEST } from '../../actions/actions'
import { FETCH_NEW_BROADCASTS_REQUEST } from '../../actions/actions'
import { toPersianDigit } from '../../helpers/nums'
import MenuItem from './MenuItem'
import SubMenuWrapper from './SidebarMenu/SubMenuWrapper'

const styles = {
  badgeStyle: {
    top: 10,
    right: 10,
    width: 19,
    height: 19,
    fontSize: 10,
  },
}

const isUserManager = userType => userType === 'MANAGER'

class Notification extends React.Component {
  componentWillMount() {
    const { dispatch, userType } = this.props
    dispatch({ type: FETCH_NEW_MESSAGES_REQUEST })

    if (!isUserManager(userType) && userType !== undefined) {
      dispatch({ type: FETCH_NEW_BROADCASTS_REQUEST, userType })
    }
  }

  render() {
    const {
      userType,
      newMessages: { result: regularMessages },
      newBroadcasts: { result: broadCasts },
      isSideBarOpen
    } = this.props

    const broadcastResultCount = broadCasts.length
    const regularMessagesCount = regularMessages.length

    const allNotifications = broadcastResultCount + regularMessagesCount
    return (
      // <div
      //   id="dd"
      //   data-badge={toPersianDigit(allNotifications)}
      //   className="wrapper-dropdown notif-badge"
      //   className="notif-badge"
      // >

      //   <MenuItem
      //     label='پشتیبانی'
      //     iconClass='fa fa-phone'
      //     pendingOrders={toPersianDigit(allNotifications)}
      //   />

        <SubMenuWrapper
          label='پشتیبانی'
          iconClass='fa fa-phone'
          isSideBarOpen={isSideBarOpen}
          className="vertical-menu"
        >

          <MenuItem
            label='تیکت جدید'
            iconClass='fa fa-plus'
            url='/dashboard/support/ticket/add'
          />

          <MenuItem
            label='همه تیکت‌ها'
            iconClass='fa fa-envelope'
            url='/dashboard/support'
          />

          {/* <MenuItem
            label='مشاهده پیام‌ها'
            iconClass='fa fa-envelope'
            url='/dashboard/messages'
            pendingOrders={toPersianDigit(regularMessagesCount)}
          /> */}

          {isUserManager(userType) && (
            <MenuItem
              label='اعلان جدید'
              iconClass='fa fa-plus'
              url='/dashboard/messages/compose'
            />
          )}

          {isUserManager(userType) && (
            <MenuItem
              label='اعلان‌های سیستم'
              iconClass='fa fa-bell'
              url='/dashboard/messages/broadcasts'
            />
          )}

          {!isUserManager(userType) && (
            <MenuItem
              label='اعلان‌های سیستم'
              iconClass='fa fa-bell'
              url='/dashboard/messages/broadcasts-inbox'
            />
          )}

          {/* {!isUserManager(userType) && (
            <MenuItem
              label='درخواست پشتیبانی'
              iconClass='fa fa-phone'
              url='/dashboard/messages/compose'
            />
          )} */}

        </SubMenuWrapper>

      // </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...selectNewMessages(state),
    ...selectNewBroadcasts(state),
    userType: state.auth.userType,
  }
}
export default connect(mapStateToProps)(Notification)



// WEBPACK FOOTER //
// ./src/components/common/Notification.js